var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { apiCreateContactToProfessionalOrganizationUnit } from '../../../actions/ContactActions';
import { apiCreateProfessionalUnitSubscribe, apiDeleteProfessionalUnitSubscribe, } from '../../../actions/ProfessionalUnitActions';
import { CONTACT_FOR_UNIT_IS_ANONYMOUS, CONTACT_FOR_UNIT_IS_NOT_ANONYMOUS, } from '../../../define/consts/contact_for_professional_organization_unit';
import { notify, wrapNotifyError, wrapDispatch } from '../../action';
import { useBoolState, usePromiseDoingCallback } from '../useHook';
/**
 * 会社情報のモーダルを制御するuse
 * @param unit
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
export const useProfessionalUnitCompanyModal = (unit, dispatch, unmountRef) => {
    const { isSubscribed: initialIsSubscribed, urlCode } = unit;
    const { boolState: isSubscribed, changeToggle: toggleIsSubscribed } = useBoolState(!!initialIsSubscribed);
    const { boolState: isShowContactModal, changeFalse: hideContactModal, changeTrue: showContactModal, } = useBoolState(false);
    const { boolState: isShowSubscribeModal, changeFalse: hideSubscribeModal, changeTrue: showSubscribeModal, } = useBoolState(false);
    const { boolState: isShowIntroductionModal, changeFalse: hideIntroductionModal, changeTrue: showIntroductionModal, } = useBoolState(false);
    /**
     * チェック状態切り替えのイベント
     * @type {(function(*): Promise<void>)|*}
     */
    const rawOnChangeSubscribe = useCallback((checked) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const callApi = checked
                ? apiDeleteProfessionalUnitSubscribe
                : apiCreateProfessionalUnitSubscribe;
            yield wrapDispatch(dispatch, callApi(urlCode));
            if (!unmountRef.current) {
                toggleIsSubscribed();
            }
        }));
    }), [dispatch, urlCode, unmountRef, toggleIsSubscribed]);
    const [onChangeSubscribe, loadingSubscribe] = usePromiseDoingCallback(rawOnChangeSubscribe, unmountRef);
    /**
     * モーダルからチェック状態の切り替えを行うイベント
     * @type {(function(*=): Promise<void>)|*}
     */
    const onChangeModalSubscribe = useCallback((checked) => __awaiter(void 0, void 0, void 0, function* () {
        yield onChangeSubscribe(checked);
        if (!unmountRef.current) {
            hideSubscribeModal();
        }
    }), [onChangeSubscribe, hideSubscribeModal, unmountRef]);
    /**
     * submit時のイベント
     * @type {(function(*): Promise<void>)|*}
     */
    const onSubmitContact = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        const values = {
            anonymous: formValues.anonymous
                ? CONTACT_FOR_UNIT_IS_ANONYMOUS
                : CONTACT_FOR_UNIT_IS_NOT_ANONYMOUS,
            contactType: parseInt(formValues.contactType, 10),
            content: formValues.content,
            questionTypeId: parseInt(formValues.questionType.value, 10),
        };
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiCreateContactToProfessionalOrganizationUnit(values, urlCode));
            if (!unmountRef.current) {
                hideContactModal();
                notify(_jsx("span", { children: "\u554F\u3044\u5408\u308F\u305B\u3092\u5B8C\u4E86\u3057\u307E\u3057\u305F" }));
                if (!isSubscribed) {
                    showSubscribeModal();
                }
            }
        }));
    }), [
        dispatch,
        urlCode,
        isSubscribed,
        hideContactModal,
        showSubscribeModal,
        unmountRef,
    ]);
    return {
        hideContactModal,
        hideIntroductionModal,
        hideSubscribeModal,
        isShowContactModal,
        isShowIntroductionModal,
        isShowSubscribeModal,
        isSubscribed,
        loadingSubscribe,
        onChangeModalSubscribe,
        onChangeSubscribe,
        onSubmitContact,
        showContactModal,
        showIntroductionModal,
        showSubscribeModal,
    };
};
export const useProfessionalUnitCompany = {
    useProfessionalUnitCompanyModal,
};
